import { useMemo } from 'react';
import { useUser } from './UserContext';

const getBrowserTimeZone = (): string | undefined => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
        return undefined;
    }
};

/**
 * ユーザー設定またはブラウザから優先タイムゾーンを取得する
 */
export const usePreferredTimeZone = (): string | undefined => {
    const { userInfo } = useUser();
    return useMemo(() => userInfo?.timeZone || getBrowserTimeZone(), [userInfo?.timeZone]);
};
